import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgFor } from '@angular/common';
import { interval, Subscription } from 'rxjs';
import { Toast, ToastService } from './corp-toast.service';

@Component({
  selector: 'corp-toast-container',
  standalone: true,
  imports: [CommonModule, NgFor],
  template: `
    <div class="fixed top-4 right-4 flex flex-col gap-3 z-[9999]">
      <div *ngFor="let toast of toastService.toasts$ | async"
           class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-lg rounded-md overflow-hidden w-80 relative">
        <div class="p-4">
          <h3 class="font-semibold text-gray-900 dark:text-white">{{ toast.title }}</h3>
          <p class="text-gray-700 dark:text-gray-300">{{ toast.message }}</p>
        </div>
        <div class="h-1 bg-primary-500 transition-[width] duration-100 ease-linear"
             [style.width.%]="toast.progress"
        ></div>
      </div>
    </div>
  `
})
export class CorpToastContainerComponent implements OnDestroy {
  private timerSub!: Subscription;

  constructor(public toastService: ToastService) {
    // tick toutes les 20ms pour mettre à jour la progression
    this.timerSub = interval(20).subscribe(() => {
      const now = Date.now();
      const current = this.toastService.toastsSubject.getValue();

current.forEach(toast => {
  if (!toast.start) {
    toast.start = now;
  }
  const elapsed = now - toast.start;
  toast.progress = Math.max(0, 100 - (elapsed / toast.duration) * 100);
});


      this.toastService.toastsSubject.next([...current]);

    });
  }

  ngOnDestroy() {
    this.timerSub.unsubscribe();
  }
}